export const PERFORMANCE_CRITICAL_PATHS = [
  "/",
  "/ai-astrologer",
  "/ai-kundli",
  "/baby-names",
  "/birth-chart",
  "/dasha-calculator",
  "/dasamsa",
  "/dwadasamsa",
  "/free-kundali",
  "/gun-milan",
  "/hi/baby-names",
  "/hi/dasamsa",
  "/hi/free-kundali",
  "/hi/gun-milan",
  "/hi/kundli-matching",
  "/hi/mangal-dosha-calculator",
  "/hi/numerology",
  "/hi/rashi-calculator",
  "/kundli-matching",
  "/lal-kitab-kundli",
  "/mangal-dosha-calculator",
  "/muhurat/travel",
  "/nakshatra-calculator",
  "/numerology",
  "/prashna-kundali",
  "/rashifal",
  "/rashi-calculator",
  "/saptamsa",
  "/shashtiamsa",
  "/tithi-today",
  "/trimsamsa",
] as const;

const PERFORMANCE_CRITICAL_PATH_SET = new Set<string>(PERFORMANCE_CRITICAL_PATHS);

export function normalizePerformancePath(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isPerformanceCriticalPath(pathname: string): boolean {
  return PERFORMANCE_CRITICAL_PATH_SET.has(normalizePerformancePath(pathname));
}
